import React , {useState , useEffect , Fragment} from 'react';

import cssClasses from "./AdmitCard.module.css";

import { useSelector } from 'react-redux';

//*MUI
import Grid from '@mui/material/Grid';
import {   getHallTicketWithPublishedExam} from '../../services/examsService';
import AdmitCard from "../../Components/AdmissionCard/AdmitCard";
import notFound from "../../assets/images/icons/not-found.png";


//* Import store
import { useDispatch } from "react-redux";
import actions from "../../Redux Store/actions";

export default function AdmitCards() {
  const dispatch = useDispatch();

  const loggedInUser = useSelector((state) => state.Auth.user);
  const [studentList, setStudentList] = useState([]);
  
  useEffect(() => {
    dispatch(actions.activeMenu('admit-cards'));
    getHallTicketData();
  }, [])

function getHallTicketData() {
   getHallTicketWithPublishedExam(loggedInUser?.docId).then(res => {
      if(res) {
          let _ticketData = res
          console.log("_ticketData" , _ticketData)
          setStudentList(_ticketData)
      } else {
          console.log("Ticket-error" , res.error)
      }
   })
}

  return (
    <div className={cssClasses.DivContainer}> 
      <p className={cssClasses.title}>Admit Cards</p>
      <Grid container >
          {
           studentList.length > 0  && studentList.map((ExamObject,index) => (
              <Fragment key={`LatestApplyCard_${ExamObject.name}_LatestApplyCard_${index+1}`}>
                  <Grid item  key={index} >
                    <AdmitCard
                    examObject={ExamObject}
                      /> 
                  </Grid>
              </Fragment>
            ))
          } 
          </Grid>  

          {
            studentList.length === 0 &&
              <div className={cssClasses.ResultsDiv }>
                  <img src={notFound} alt={""}  width="40px" height="40px" style={{alignSelf:"center"}}/>
                  <p className={cssClasses.title} style={{alignSelf:"center"}}>no results found!</p>
              </div> 
          }
      </div>
  )
}
